import { useNotificationUnread } from "context/NotificationUnreadContext";

/**
 * Unread in-app notification count + refetch when `notification:new` fires (same source as header bell).
 */
export function useNotificationUnreadCount() {
  const { unreadCount, refreshUnread } = useNotificationUnread();
  return { unreadCount, refetchUnreadCount: async () => refreshUnread() };
}
